<app-modal
  [title]="''"
  [confirmLabel]="'Zapisz'"
  [cancelLabel]="'Anuluj'"
  [showConfirm]="true"
  [showCancel]="true"
  [isConfirmDisabled]="isFormInvalid"
  [onConfirmAction]="saveClient.bind(this)"
>
  <app-client-form
    [client]="client"
    [clients]="clients"
    [onValidityChange]="onValidityChange.bind(this)"
  />
</app-modal>
